import { Injectable } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { environment } from "environments/environment.e2e";

@Injectable()
export class StructuredDataService {

  private _jsons =  {
    WebApplication: {
      "@context": "https://schema.org",
      "@type": "WebApplication",
      "name": undefined,
      "url": undefined,
      "description": undefined,
      "featureList": undefined,
      "applicationCategory": "HomeApplication",
      "applicationSubCategory": "DesignApplication",
      "image":undefined,
      "author":{
        "@type": "Organization",
        "name": "Kozikaza, IDILINK, SARL",
        "url": "https://www.kozikaza.com",
        "telephone": "0033359315300",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "135 rue Sadi Carnot",
          "addressLocality": "Ronchin",
          "addressRegion": "Hauts-de-France",
          "postalCode": "59790",
          "addressCountry": "FR"
        },
        "logo": {
          "@type": "ImageObject",
          "url": undefined,
          "height": "116",
          "width": "116"
        }
      },
      "screenshot": undefined,
      "availableOnDevice": ["iPad", "Mac", "Windows"],
      "operatingSystem": [
        "Windows 7",
        "Windows 8",
        "Windows 10",
        "OSX 10.9",
        "OSX 10.10",
        "OSX 10.11",
        "OSX 10.12",
        "OSX 10.13",
        "OSX 10.14"
      ],
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.81",
        "ratingCount": "2723"
      },
      "offers": {
        "@type": "Offer",
        "price": "0",
        "priceCurrency":"EUR",
      }
    },
    FAQPage: new FAQPageEntity()
  };

  constructor(
      private sanitizer: DomSanitizer,
  ) { }


  getJsonWebApplication(
    name: string,
    url: string,
    description: string,
    featureList: string,
    image: string,
    author_logo_url: string,
    screenshots: Array<string>,
  ): any {
    this._jsons.WebApplication.name = name;
    this._jsons.WebApplication.url = url;
    this._jsons.WebApplication.description = description;
    this._jsons.WebApplication.featureList = featureList;
    this._jsons.WebApplication.image = image;
    this._jsons.WebApplication.author.logo.url = author_logo_url;
    this._jsons.WebApplication.screenshot = screenshots;
    return this.getSafeHTML(this._jsons.WebApplication);
  }

  getJsonFAQ(questions: Array<FAQPageEntityQuestion>): any {
    this._jsons.FAQPage.mainEntity = questions;
    return this.getSafeHTML(this._jsons.FAQPage);
  }


  getJsonFAQFromComponents(questions: Array<string>, responses: Array<String>): any {
    // Structured Data
    const mainEntity: Array<FAQPageEntityQuestion> = [];
    questions.forEach((question, index) => {
      mainEntity.push({
        "@type": 'Question',
        name: question,
        acceptedAnswer: {
          "@type": 'Answer',
          text: responses[index]
            .replace(/<app-picture-source.*?>.*?<\/app-picture-source>/ig,'')
            .replace(/<svg.*?>.*?<\/svg>/ig,'')
            .replace(/<!---->/ig,'')
            .replace(/<div.*?>(.*?)<\/div>/ig,'$1')
            .replace(/href="\//ig,'href="'+ environment.REDIRECT_URL + "/")
          ,
        }
      })
    });
    return this.getJsonFAQ(mainEntity);
  }
  private getSafeHTML(value: {}): SafeHtml {
    // If value convert to JSON and escape / to prevent script tag in JSON
    const jsonString = value ? JSON.stringify(value, null, 2) : '';
    const html = `<script type="application/ld+json">${jsonString}</script>`;
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}

export interface StructuredDataI {
  "@type": string;
  "@context": string;
}

export class FAQPageEntity implements StructuredDataI   {
  "@context" = "https://schema.org";
  "@type" = 'FAQPage';
  mainEntity: Array<FAQPageEntityQuestion>;

  constructor(
    mainEntity?: Array<FAQPageEntityQuestion>,
  ) {
    this.mainEntity = mainEntity;
  }

}
export class FAQPageEntityQuestion {
  "@type" = 'Question';
  name: string;
  acceptedAnswer: FAQPageEntityAnswer;
}
export class FAQPageEntityAnswer {
  "@type" = 'Answer';
  text: string;
}
